import { Field } from 'devextreme/ui/pivot_grid/data_source';
import {
  adat_tipus_group,
  felhasznalasi_cel_group,
  tetelek_group,
  tevekenyseg_group,
  termekek_group,
  keszletek_group,
  engedelyes_group,
  orszag_group,
  regiok_es_varmegyek_group,
  fogyasztasi_sav_group
} from './common';

export const dimensiondata_1_dimension_1: Field = {
  dataField: 'dimensiondata_1.label',
  sortBy: 'none',
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_1_dimension_1_w150: Field = {
  dataField: 'dimensiondata_1.label',
  sortBy: 'none',
  width: 150,
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_1_dimension_w200: Field = {
  dataField: 'dimensiondata_1.label',
  sortBy: 'none',
  width: 200,
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_1_dimension_w300: Field = {
  dataField: 'dimensiondata_1.label',
  sortBy: 'none',
  width: 300,
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_1_dimension_2: Field = {
  ...dimensiondata_1_dimension_1,
  dataField: 'dimensiondata_1.child.label',
};

export const dimensiondata_1_dimension_2_w200: Field = {
  ...dimensiondata_1_dimension_1,
  dataField: 'dimensiondata_1.child.label',
  width: 200,
};

export const dimensiondata_1_dimension_3: Field = {
  ...dimensiondata_1_dimension_1,
  dataField: 'dimensiondata_1.child.child.label',
};

export const dimensiondata_1_dimension_4: Field = {
  ...dimensiondata_1_dimension_1,
  dataField: 'dimensiondata_1.child.child.child.label',
};

export const dimensiondata_1_dimension_5: Field = {
  ...dimensiondata_1_dimension_1,
  dataField: 'dimensiondata_1.child.child.child.child.label',
};

export const dimensiondata_1_tetelek: Field[] = [
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];

export const dimensiondata_1_tetelek_group_1_2_3_4: Field[] = [
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tetelek', groupIndex: 3 },
];

export const dimensiondata_1_tetelek_group_1_2_3: Field[] = [
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_1_tetelek_group_1_2: Field[] = [
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
];


export const dimensiondata_1_tetelek_group_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
];

export const dimensiondata_1_tetelek_group_1_2_3_4_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  ...dimensiondata_1_tetelek_group_1_2_3_4,
];

export const dimensiondata_1_tetelek_group_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  ...dimensiondata_1_tetelek,
];

export const dimensiondata_1_tetelek_group_dimension_1_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
];

export const dimensiondata_1_tetelek_group_dimension_1_2_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  ...dimensiondata_1_tetelek_group_1_2,
];

export const dimensiondata_1_tetelek_group_dimension_1_2_3_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  ...dimensiondata_1_tetelek_group_1_2_3,
];

export const dimensiondata_1_tetelek_group_dimension_1_2_row_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
];

export const dimensiondata_1_tetelek_group_dimension_1_2_3_row_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_1_tetelek_group_dimension_1_2_3_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: false,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_1_tetelek_group_dimension_1_2_3_row_w200: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: false,
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_1_tetelek_group_dimension_1_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];


export const dimensiondata_1_tetelek_group_dimension_1_2_3_4_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tetelek', groupIndex: 3 },
];

export const dimensiondata_1_tetelek_group_dimension_1_2_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
];

export const dimensiondata_1_termekek_group_first_row_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'termekek', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'termekek', groupIndex: 4 },
];

export const dimensiondata_1_termekek_group_dimension_1_2_row_w200: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: false,
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_1_keszletek_group_row: Field[] = [
  {
    ...keszletek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_1, groupName: 'keszletek', groupIndex: 0 },

];

export const dimensiondata_1_keszletek_group_row_w300: Field[] = [
  {
    ...keszletek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w300, groupName: 'keszletek', groupIndex: 0 },

];

export const dimensiondata_1_engedelyes_group_row: Field[] = [
  {
    ...engedelyes_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_1_w150, groupName: 'engedelyes', groupIndex: 0 },

];

// export const dimensiondata_1_felhasznalasi_cel: Field[] = [
//   { ...dimensiondata_1_dimension_1, groupName: 'felhasznalasi_cel', groupIndex: 0 },
//   { ...dimensiondata_1_dimension_2, groupName: 'felhasznalasi_cel', groupIndex: 1 },
//   { ...dimensiondata_1_dimension_3, groupName: 'felhasznalasi_cel', groupIndex: 2 },
//   { ...dimensiondata_1_dimension_4, groupName: 'felhasznalasi_cel', groupIndex: 3 },
//   { ...dimensiondata_1_dimension_5, groupName: 'felhasznalasi_cel', groupIndex: 4 },
// ];

export const dimensiondata_1_felhasznalasi_cel_group_row: Field[] = [
  {
    ...felhasznalasi_cel_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'felhasznalasi_cel', groupIndex: 0 },
  // ...dimensiondata_1_felhasznalasi_cel,
];

export const dimensiondata_1_tevekenyseg: Field[] = [
  { ...dimensiondata_1_dimension_1, groupName: 'tevekenyseg', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tevekenyseg', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tevekenyseg', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tevekenyseg', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'tevekenyseg', groupIndex: 4 },
];

export const dimensiondata_1_tevekenyseg_group_row: Field[] = [
  {
    ...tevekenyseg_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  ...dimensiondata_1_tevekenyseg,
];

export const dimensiondata_1_tevekenyseg_group_dimension_1_first_row_expanded: Field[] = [
  {
    ...tevekenyseg_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tevekenyseg', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2, groupName: 'tevekenyseg', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tevekenyseg', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tevekenyseg', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'tevekenyseg', groupIndex: 4 },
];


export const dimensiondata_1_tevekenyseg_group_dimension_1_2_3_4_first_row_expanded: Field[] = [
  {
    ...tevekenyseg_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_1, groupName: 'tevekenyseg', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2, groupName: 'tevekenyseg', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tevekenyseg', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tevekenyseg', groupIndex: 3 },
];

export const dimensiondata_1_tevekenyseg_group_dimension_1_2_3_4_first_row_expanded_w200: Field[] = [
  {
    ...tevekenyseg_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tevekenyseg', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2_w200, groupName: 'tevekenyseg', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tevekenyseg', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tevekenyseg', groupIndex: 3 },
];

export const dimensiondata_1_tevekenyseg_group_dimension_1_2_3_first_row_expanded_w200: Field[] = [
  {
    ...tevekenyseg_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord'
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tevekenyseg', groupIndex: 0, expanded: true },
  { ...dimensiondata_1_dimension_2_w200, groupName: 'tevekenyseg', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tevekenyseg', groupIndex: 2 },
];


// export const dimensiondata_1_tevekenyseg_group_dimension_1_column: Field[] = [
//   {
//     ...tevekenyseg_group,
//     area: 'column',
//     sortBySummaryField: 'dimensiondata_1.ord'
//   },
//   { ...dimensiondata_1_dimension0, groupName: 'tevekenyseg', groupIndex: 0 },
// ];

// export const dimensiondata_1_tevekenyseg_group_w200_row: Field[] = [
//   {
//     ...tevekenyseg_group,
//     area: 'row',
//     sortBySummaryField: 'dimensiondata_1.ord'
//   },
//   { ...dimensiondata_1_dimension_w200, groupName: 'tevekenyseg', groupIndex: 0 },
// ];
//

export const dimensiondata_1_dimension_1_import_filter: Field[] = [
  {
    ...adat_tipus_group,
    area: 'filter',
    filterValues: [['Import']],
  },
  {
    ...dimensiondata_1_dimension_1,
    groupName: 'adat_tipus',
    groupIndex: 0,
  },
];

export const dimensiondata_1_tetelek_group_w200_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tetelek', groupIndex: 0 },
];

export const dimensiondata_1_tetelek_1_2_group_w200_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
];

export const dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];

export const dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_1_termekek_group_dimension_1_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
 { ...dimensiondata_1_dimension_1, groupName: 'termekek', groupIndex: 0 },
];

export const dimensiondata_1_termekek_group_dimension_1_row: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
 { ...dimensiondata_1_dimension_1, groupName: 'termekek', groupIndex: 0 },
];

export const dimensiondata_1_termekek_group_w200_row: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'termekek', groupIndex: 0 },
];

export const dimensiondata_1_fogyasztasi_sav_group_w300_row: Field[] = [
  {
    ...fogyasztasi_sav_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_w300, groupName: 'fogyasztasi_sav', groupIndex: 0 },
];

export const dimensiondata_1_orszag_group_dimension_1_2_3_row_expanded: Field[] = [
  {
    ...orszag_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'orszag', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'orszag', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'orszag', groupIndex: 2 },
];

export const dimensiondata_1_orszag_group_dimension_1_2_row_expanded: Field[] = [
  {
    ...orszag_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
    expanded: true,
  },
  { ...dimensiondata_1_dimension_1, groupName: 'orszag', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'orszag', groupIndex: 1 },
];

export const dimensiondata_1_regiok_es_varmegyek: Field[] = [
  { ...dimensiondata_1_dimension_w200, groupName: 'regiok_es_varmegyek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'regiok_es_varmegyek', groupIndex: 1 },
  { ...dimensiondata_1_dimension_3, groupName: 'regiok_es_varmegyek', groupIndex: 2 },
  { ...dimensiondata_1_dimension_4, groupName: 'regiok_es_varmegyek', groupIndex: 3 },
  { ...dimensiondata_1_dimension_5, groupName: 'regiok_es_varmegyek', groupIndex: 4 },
];

export const dimensiondata_1_regiok_es_varmegyek_group_dimension_1_2_row: Field[] = [
  {
    ...regiok_es_varmegyek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  { ...dimensiondata_1_dimension_w200, groupName: 'regiok_es_varmegyek', groupIndex: 0 },
  { ...dimensiondata_1_dimension_2, groupName: 'regiok_es_varmegyek', groupIndex: 1 },
];

export const dimensiondata_1_regiok_es_varmegyek_group_row: Field[] = [
  {
    ...regiok_es_varmegyek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_1.ord',
  },
  ...dimensiondata_1_regiok_es_varmegyek,
];

